import { Box, Stepper, styled, Typography } from '@mui/material';

const ScrollableContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isExpanded' && prop !== 'fixedHeight',
})<{ isExpanded?: boolean; fixedHeight?: number }>(({ isExpanded, fixedHeight }) => ({
  ...(fixedHeight
    ? { height: `${fixedHeight}px`, overflowY: 'auto' as const }
    : { height: isExpanded ? '420px' : '270px', overflowY: isExpanded ? 'visible' as const : 'auto' as const }),
  overflowX: 'hidden',
  width: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#ccc',
    borderRadius: '3px',
    '&:hover': {
      background: '#999',
    },
  },
}));

const StyledStepper = styled(Stepper)({
  '& .MuiStep-root': {
    padding: 0,
    width: 'fit-content',
    '& .MuiStepLabel-root': {
      padding: 0,
    },
    '& .MuiStepLabel-labelContainer': {
      width: 'auto',
    },
  },
  '& .MuiStepConnector-line': {
    minHeight: 16,
  },
});

const UndoBubble = styled(Box)({
  position: 'relative',
  backgroundColor: '#fef3c7',
  border: '1px solid #fcd34d',
  borderRadius: '10px',
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '6px',
  paddingBottom: '6px',
  whiteSpace: 'nowrap',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: -9,
    top: '50%',
    transform: 'translateY(-50%)',
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    borderRight: '8px solid #fcd34d',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    left: -7,
    top: '50%',
    transform: 'translateY(-50%)',
    borderTop: '7px solid transparent',
    borderBottom: '7px solid transparent',
    borderRight: '7px solid #fef3c7',
  },
});

const UndoBubbleText = styled(Typography)({
  fontSize: '0.8rem',
});

const UndoLink = styled('span')({
  textDecoration: 'underline',
  cursor: 'pointer',
  fontWeight: 700,
  color: '#92400e',
});

export { ScrollableContainer, StyledStepper, UndoBubble, UndoBubbleText, UndoLink };
